/** The public page that resets a forgotten password; B2C's "Forgot your password?" ends here. */
export const resetPasswordPath = '/reset-password'
